import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    id: "faq",
    class: "faq"
};
const _hoisted_2 = { class: "faq__header" };
const _hoisted_3 = { class: "faq__label" };
const _hoisted_4 = { class: "faq__title" };
const _hoisted_5 = { class: "faq__list" };
const _hoisted_6 = ["aria-expanded", "aria-controls", "onClick"];
const _hoisted_7 = { class: "faq__q-text" };
const _hoisted_8 = ["id"];
const _hoisted_9 = { class: "faq__a-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_reveal = _resolveDirective("reveal");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("header", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('faq.label')), 1),
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('faq.title')), 1)
        ])), [
            [_directive_reveal]
        ]),
        _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
                return _withDirectives((_openBlock(), _createElementBlock("li", {
                    key: item.q,
                    class: _normalizeClass(["faq__item", { 'faq__item--open': _ctx.open === idx }])
                }, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "faq__question",
                        "aria-expanded": _ctx.open === idx,
                        "aria-controls": `faq-a-${idx}`,
                        onClick: ($event) => (_ctx.toggle(idx))
                    }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.q), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("span", {
                            class: "faq__icon",
                            "aria-hidden": "true"
                        }, null, -1))
                    ], 8, _hoisted_6),
                    _createElementVNode("div", {
                        id: `faq-a-${idx}`,
                        class: "faq__answer",
                        role: "region"
                    }, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(item.a), 1)
                    ], 8, _hoisted_8)
                ], 2)), [
                    [_directive_reveal, { delay: idx * 30 }]
                ]);
            }), 128))
        ])
    ]));
}
